/* This is a mst-gql generated file, don't modify it manually */
/* eslint-disable */
/* tslint:disable */
import { types } from "mobx-state-tree"

/**
 * Typescript enum
 */

export enum DeliveryMethod {
  NONE="NONE",
EMAIL="EMAIL",
SMS="SMS"
}

/**
* DeliveryMethod
*/
export const DeliveryMethodEnumType = types.enumeration("DeliveryMethod", [
        "NONE",
  "EMAIL",
  "SMS",
      ])
